import React from 'react';
import _ from 'lodash';
import styled from '@emotion/styled';
import AddIcon from '~Assets/icons/add.svg';
import Icon from '~ComponentsImproved/Icon';

const Wrapper = styled.div`
  width: 216px;
  height: 48px;
  background-color: var(--colorBlueGray1200);
  margin: 0 2px;
  box-sizing: border-box;
  position: relative;
  border-radius: 4px 4px 0px 0px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

interface Props {
  onNewTab: () => void;
}

const NewTabButton: React.FunctionComponent<Props> = ({ onNewTab }) => {
  return (
    <Wrapper onTouchStart={onNewTab}>
      <Icon src={AddIcon} color="var(--colorWhite)" />
    </Wrapper>
  );
};

export default NewTabButton;
